import React from 'react'
import SearchBox from './search-box';
import FilterBox from './filter-box';


const Sidebar = (props) => {
	return (
		<React.Fragment>
			<SearchBox onChangeInput={props.onChangeInput}/>
			<FilterBox updateView = {props.filterFunction}/>
		</React.Fragment>
	)
}

export default Sidebar


// WEBPACK FOOTER //
// ./src/components/sidebar.jsx